<div class="mx-xl-0 p-5 px-xl-7 py-xl-8 evisa-bg-white rounded-5" [ngClass]="!showCloseBtn ? 'my-8 my-lg-13' : ''">
    @if (showCloseBtn) {
    <div class="d-flex justify-content-end">
        <img class="m-3 c-pointer" src="assets/icons/close-blue.svg" (click)="activeModal.dismiss('Cross click')">
    </div>
    }
    <div class="col-12 d-flex justify-content-center">
        <div class="">
            <p class="heading-2 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.TITLE' | translate"></p>

            <div class="content-wrapper my-2">
                <p class="text-2 text-blue-2 ibm-medium line-7" [innerHTML]="'PRIVACY_POLICY.INTRO' | translate"></p>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_1.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_1.SUBSECTION_1.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_1.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_1.SUBSECTION_2.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_1.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_2.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_2.SUBSECTION_1.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_2.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_2.SUBSECTION_2.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_2.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_3.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_3.SUBSECTION_1.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_3.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_3.SUBSECTION_2.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_3.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_4.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="text-2 text-blue-2 ibm-medium line-7"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_4.CONTENT' | translate"></p>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_5.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_5.SUBSECTION_1.TITLE' | translate"></p>
                <div class="content-wrapper mx-2 p-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_5.SUBSECTION_1.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_5.SUBSECTION_2.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_5.SUBSECTION_2.CONTENT' | translate"></p>
                </div>
            </div>

            <div class="content-wrapper m-2">
                <p class="heading-4 ibm-semibold linear-gradient-text"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_5.SUBSECTION_3.TITLE' | translate"></p>
                <div class="content-wrapper m-2">
                    <p class="text-2 text-blue-2 ibm-medium line-7"
                        [innerHTML]="'PRIVACY_POLICY.SECTION_5.SUBSECTION_3.CONTENT' | translate"></p>
                </div>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_6.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="text-2 text-blue-2 ibm-medium line-7"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_6.CONTENT' | translate"></p>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_7.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="text-2 text-blue-2 ibm-medium line-7"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_7.CONTENT' | translate"></p>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_8.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="text-2 text-blue-2 ibm-medium line-7"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_8.CONTENT' | translate"></p>
            </div>

            <p class="heading-3 ibm-semibold linear-gradient-text pb-2"
                [innerHTML]="'PRIVACY_POLICY.SECTION_10.TITLE' | translate"></p>
            <div class="content-wrapper m-2">
                <p class="text-2 text-blue-2 ibm-medium line-7"
                    [innerHTML]="'PRIVACY_POLICY.SECTION_10.CONTENT' | translate"></p>
            </div>

        </div>
    </div>
</div>